var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.value
    ? _c(
        "div",
        { staticClass: "tile is-child box" },
        [
          _vm.hasFactory
            ? _c(
                "bulma-table",
                {
                  staticClass:
                    "table is-bordered is-striped is-narrow is-fullwidth",
                  attrs: {
                    columns: _vm.columns,
                    "total-rows": _vm.totalRows,
                    "is-loading": _vm.isTableLoading,
                    "show-pagination": false,
                  },
                },
                [
                  _vm._l(_vm.value, function (v, index) {
                    return _c(
                      "tr",
                      {
                        key: index,
                        class: { "is-selected": _vm.selectedRow === index },
                        on: {
                          click: function ($event) {
                            return _vm.highlightSelected(index, $event)
                          },
                        },
                      },
                      [
                        _c("td", [_vm._v(_vm._s(v.factory.make))]),
                        _c("td", [_vm._v(_vm._s(v.factory.model))]),
                        _c("td", [_vm._v(_vm._s(v.factory.series))]),
                        _c("td", [_vm._v(_vm._s(v.factory.variant))]),
                        _c("td", [_vm._v(_vm._s(v.factory.body))]),
                        _c("td", [_vm._v(_vm._s(v.colour))]),
                        _c("td", [_vm._v(_vm._s(v.engine_number))]),
                        _c("td", [_vm._v(_vm._s(v.factory.litres))]),
                        _c("td", [_vm._v(_vm._s(v.factory.transmission))]),
                        _c("td", [_vm._v(_vm._s(v.vehicle_type))]),
                        _c("td", [_vm._v(_vm._s(v.factory.buildYear))]),
                      ]
                    )
                  }),
                  _c("template", { slot: "empty" }, [
                    _c("section", { staticClass: "section" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "content has-text-grey has-text-centered",
                        },
                        [
                          _c("span", { attrs: { icon: "icon is-large" } }, [
                            _c("i", {
                              staticClass: "mdi mdi-48px mdi-emoticon-sad",
                            }),
                          ]),
                          _c("p", [_vm._v("Nothing")]),
                        ]
                      ),
                    ]),
                  ]),
                ],
                2
              )
            : _c(
                "bulma-table",
                {
                  staticClass:
                    "table is-bordered is-striped is-narrow is-fullwidth",
                  attrs: {
                    columns: _vm.columns,
                    "total-rows": _vm.totalRows,
                    "is-loading": _vm.isTableLoading,
                    "show-pagination": false,
                  },
                },
                [
                  _vm._l(_vm.value, function (v, index) {
                    return _c(
                      "tr",
                      {
                        key: index,
                        class: { "is-selected": _vm.selectedRow === index },
                        on: {
                          click: function ($event) {
                            return _vm.highlightSelected(index, $event)
                          },
                        },
                      },
                      [
                        _c("td", [_vm._v(_vm._s(v.blueflag_make))]),
                        _c("td", [_vm._v(_vm._s(v.blueflag_model))]),
                        _c("td", [_vm._v(_vm._s(v.body_type))]),
                        _c("td", [_vm._v(_vm._s(v.colour))]),
                        _c("td", [_vm._v(_vm._s(v.engine_number))]),
                        _c("td", [_vm._v(_vm._s(v.vehicle_type))]),
                        _c("td", [_vm._v(_vm._s(v.year_of_manufacture))]),
                      ]
                    )
                  }),
                  _c("template", { slot: "empty" }, [
                    _c("section", { staticClass: "section" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "content has-text-grey has-text-centered",
                        },
                        [
                          _c("span", { attrs: { icon: "icon is-large" } }, [
                            _c("i", {
                              staticClass: "mdi mdi-48px mdi-emoticon-sad",
                            }),
                          ]),
                          _c("p", [_vm._v("Nothing")]),
                        ]
                      ),
                    ]),
                  ]),
                ],
                2
              ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }